import React, { useEffect, useState } from "react";
import { Attachment, Button, Checkbox, Col, DragDrop, HelpText, Input, Row, Slider, Toast, Tooltip, DatePicker } from "@kaleyra/emmy";
import Styles from './index.module.scss';
import { useTranslation } from "react-i18next";
import { isEmpty, sample } from "lodash";
import downloadIcon from "../../../../assets/download-blue.svg";
import { validateTxtlyUrl } from "../../../../utils";
import moment,{ Moment } from "moment";

export type MapStateType = {
    viewData: any;
    isEdit: any;
};

export type DispatchPropsType = {
    onSave: (formData: any, callback: (resp: any, flag: boolean) => void) => void;
    onEdit: (formData: any, callback: (resp: any, flag: boolean) => void) => void;
    onClose: () => void;
    onLoad: (filters?: any, SearchStr?: string) => void;
};

const BulkURLShortenerForm: React.FC<MapStateType & DispatchPropsType> = ({
    onSave, onClose, isEdit, viewData, onEdit, onLoad }) => {
    const { t } = useTranslation();
    const {
        SearchStr,
        filters
    } = isEdit?.extraParam;
    const [urlTitle, setUrlTitle] = useState<string>("");
    const [callbackUrl, setCallbackUrl] = useState<string>("");
    const [trackUserStatus, setTrackUserStatus] = useState<boolean>(false);
    const [uploadedDocument, setUploadedDocument] = useState<any>([]);
    const [isFileAttached, setIsFileAttached] = useState<boolean>(false);
    const [selecteddate, setSelectedDate] = useState<Moment|null>(null);

    const formatPostData = (): FormData => {
        let formDataOb = new FormData();
        formDataOb.append('title', urlTitle);
        if (!isEmpty(callbackUrl)) {
            formDataOb.append('callback_url', callbackUrl);
        }
        if (isFileAttached) {
            formDataOb.append('file', uploadedDocument[0]);
        }
        formDataOb.append('is_advanced', trackUserStatus ? "on" : "off");
        if(selecteddate){
            formDataOb.append('expiry', selecteddate?.format('YYYY-MM-DD HH:mm:ss'));
        }
        return formDataOb;
    }

    const handleSaveCallback = (response: any, flag: boolean) => {
        if (flag) {
            Toast(response.message, "success");
            onLoad(filters, SearchStr);
            onClose();
        } else {
            Toast(response.data?.message, "error")
        }
    }

    const handleFormSave = () => {
        const postRequestBody = formatPostData();
        onSave(postRequestBody, handleSaveCallback)
    }

    const isTitleValid = (): boolean => {
        return urlTitle?.length !== 0 && urlTitle?.length <= 100;
    }

    const isCallbackURLValid = (): boolean => {
        return callbackUrl === undefined || callbackUrl?.length === 0 || validateTxtlyUrl(callbackUrl);
    }

    const isFormValid = (): boolean => {
        return isFileAttached && isTitleValid() && isCallbackURLValid()
    }


    const onFileSelect = (file: any, isValid: boolean) => {
        if (isValid) {
            setIsFileAttached(true);
            setUploadedDocument(file);
        } else {
            Toast(t('F104'), "error");
        }
    }

    const getFileType = (): string => {
        return uploadedDocument[0]?.name.split(".")[1];
    }

    const getFileName = (): string => {
        return uploadedDocument[0]?.name || "";
    }

    const onDeleteAttachment = () => {
        setUploadedDocument([]);
        setIsFileAttached(false);
    }

    const handleSampleFileDownload = () => {
        const sampleFilePath = process.env.REACT_APP_TEXTLY_DOWNLOAD_SAMPLE;
        if (sampleFilePath) {
            window.open(sampleFilePath, '_blank');
        }
    }

    const renderFormBody = () => {
        return (
            <>
                <div>
                    <Input label={t('BLD02007')} placeholder={t('BLD02007')} value={urlTitle} onChange={(e: any) => setUrlTitle(e.target.value)} bottomLabelType={(urlTitle?.length === 0 || isTitleValid() ? "default" : "error")} />
                </div>
                {!isFileAttached ?
                    <div className={Styles.dragDropWrapper}>
                        <DragDrop fileFormats={'.csv, .xls, .xlsx'} multiple={false} onChange={onFileSelect} />
                        <Row className={Styles.downloadLinkRow}>
                            <span className={Styles.downloadText} onClick={handleSampleFileDownload}>{t('camDownloadSampleFile')}</span>
                        </Row>
                    </div> :
                    <>
                        <div className={Styles.attachmentWrapper}>
                            <Attachment fileType={getFileType()} fileName={getFileName()} id={"id"} onClose={() => onDeleteAttachment()} />
                        </div>
                    </>
                }
                <div>
                    <Input label={t('BLD02011')} placeholder={t('BLD02011')} value={callbackUrl} onChange={(e: any) => setCallbackUrl(e.target.value)} bottomLabelType={isCallbackURLValid() ? "default" : "error"} />
                </div>
                <Row>
                    <Col size={12}>
                        <Checkbox label={t('BLD02012')} className={Styles.checkbox} checked={trackUserStatus} onChange={(event: any) => setTrackUserStatus(event.target.checked)} />
                    </Col>
                </Row>
                <div className={Styles.datePickerWrapper}>
					<div>{t('urlExpiryHeading')}</div>
					<DatePicker
						style={{ width: '100%' }}
						value={selecteddate}
						onChange={(date: any) => setSelectedDate(date)}
						disabledDate={(date) => {
							return (
								date &&
								!(
									date >
										moment().add(1, 'day').startOf('day') &&
									date < moment().add(1, 'year').endOf('day')
								)
							);
						}}
					/>
					<div className={Styles.desc}>{t('urlExpiryDescption')}</div>
				</div>
                <div className={Styles.footerPosition}>
                    <Button type="tertiary" onClick={onClose}>
                        {t('mainCancel')}
                    </Button>
                    <Button type="primary" onClick={() => handleFormSave()} disabled={!isFormValid()}>
                        {t('mainSave')}
                    </Button>
                </div>
            </>
        );
    }

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            title={t('BLD02021')}
        >
            <div className={Styles.container}>
                {renderFormBody()}
            </div>
        </Slider>
    )
}

export default BulkURLShortenerForm;